import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'forms-geo-input',
  templateUrl: './geo.component.html',
  styleUrls: ['./geo.component.scss'],
})
export class GeoComponent implements OnInit {
  @Input() control: UntypedFormControl;
  @Input() zoom = 8;
  @Input() bounds: google.maps.LatLngBoundsLiteral;
  @Input() height = '300px';
  @Input() tooltip: string;

  mapOptions$: Observable<google.maps.MapOptions>;
  markerOptions$: Observable<google.maps.MarkerOptions>;

  ngOnInit(): void {
    const valueChanges = this.control.valueChanges.pipe(shareReplay(1));
    this.mapOptions$ = valueChanges.pipe(
      map((values) => {
        return <google.maps.MapOptions>{
          center: {
            lat: values.latitude,
            lng: values.longitude,
          },
          zoom: this.zoom,
          mapTypeControl: false,
        };
      }),
    );

    this.markerOptions$ = valueChanges.pipe(
      map((values) => {
        return <google.maps.MarkerOptions>{
          position: {
            lat: values.latitude,
            lng: values.longitude,
          },
          draggable: true,
        };
      }),
    );
  }

  updateControl($event: google.maps.MapMouseEvent): void {
    this.control.setValue({ latitude: $event.latLng.lat(), longitude: $event.latLng.lng() });
    this.control.markAsDirty();
    this.control.markAsTouched();
  }

  updateControlIfUnset($event: google.maps.MapMouseEvent): void {
    if (!this.control.value) {
      this.updateControl($event);
    }
  }
}
